import { Controller } from "stimulus";
import Tagify from '@yaireo/tagify'

export default class extends Controller {
  static targets = [
    'skillTagField',
  ];

  updateProfession(e) {
    this.skillTagFieldController.setProfessionId(e.currentTarget.value);
  }

  get skillTagFieldController() {
    return this.application.getControllerForElementAndIdentifier(
      this.skillTagFieldTarget,
      "skill-tag-field"
    );
  }
}
